import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppLayoutModule } from './layout/app.layout.module';
import { NotfoundComponent } from './demo/components/notfound/notfound.component';
import { ProductService } from './demo/service/product.service';
import { CountryService } from './demo/service/country.service';
import { CustomerService } from './demo/service/customer.service';
import { EventService } from './demo/service/event.service';
import { IconService } from './demo/service/icon.service';
import { NodeService } from './demo/service/node.service';
import { PhotoService } from './demo/service/photo.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgOtpInputModule } from 'ng-otp-input';
import { MessageService } from 'primeng/api';
import { NgxUiLoaderConfig, NgxUiLoaderModule, NgxUiLoaderHttpModule } from 'ngx-ui-loader';
import { TranslocoModule, TRANSLOCO_CONFIG, translocoConfig, TranslocoService } from '@ngneat/transloco';
import { MsalInterceptor, MsalModule, MsalRedirectComponent } from '@azure/msal-angular';

import { InteractionType, PublicClientApplication } from '@azure/msal-browser';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {

}; import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InterceptorService } from './@core/services/interceptor.service';
import { AuthGuard } from './@core/Guards/auth.guard';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { TranslocoRootModule } from './transloco-root.module';
import { environment } from 'src/environments/environment';
import { DialogModule } from 'primeng/dialog';

const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
const isIE = window.navigator.userAgent.indexOf('MSIE') > -1
    || window.navigator.userAgent.indexOf('Trident/') > -1

@NgModule({
    declarations: [AppComponent, NotfoundComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgOtpInputModule,
        MessageModule,
        MessagesModule,
        ToastModule,
        TranslocoModule,
        TranslocoRootModule,
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        NgxUiLoaderHttpModule.forRoot({
            showForeground: false, // Disabled - using component-level loaders instead
            maxTime: 5,
        }),
        MsalModule.forRoot(new PublicClientApplication
            (
                {
                    auth: {
                        clientId: environment.clientIdAzure,

                        redirectUri: environment.redirectUrl,

                        postLogoutRedirectUri: environment.redirectUrl + '/#/auth/sign-in',
                        authority: environment.AuthorityAzure,

                    },
                    cache:
                    {
                        cacheLocation: 'localStorage',
                        storeAuthStateInCookie: isIE
                    }
                }
            ),
            {
                interactionType: InteractionType.Redirect,
                authRequest: {
                    scopes: [environment.ScopeAzure],

                }
            },
            {
                interactionType: InteractionType.Redirect,
                protectedResourceMap: new Map(
                    [
                        ['https://graph.microsoft.com/v1.0/me', ['user.Read']],
                        ['impact-portal-dev.mvola.mg', [environment.ScopeAzure]]


                    ]
                )
            }
        ),
        DialogModule
    ],
    providers: [
        AuthGuard,
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        CountryService,
        CustomerService,
        EventService,
        IconService,
        NodeService,
        PhotoService,
        ProductService,
        MessageService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true
        },
        {
            provide: TRANSLOCO_CONFIG,
            useValue: translocoConfig({
                availableLangs: ['en', 'fr'],
                defaultLang: selectedLanguage,
                reRenderOnLangChange: true,
                prodMode: environment.production,
                fallbackLang: 'en',
                flatten: {
                    aot: true
                },
                missingHandler: {
                    logMissingKey: false,
                    useFallbackTranslation: true
                }
            }),
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        
    ],
    bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule { }
